// Audit logs list page (CHG-1643 / Wave 1 Tier 1).
//
// Org-scoped at /audit-logs. Platform-scoped variant mounted at
// /platform/audit-logs (and /platform/audit alias kept in route table
// for the deep-link compat documented in CHG-1551).
//
// Spec: specs/tier-05-experience/audit-logs.cross-screen.yaml.

import { ListPage } from "../components/composition";
import {
  auditLogsListConfig,
  platformAuditLogsListConfig,
} from "../screens/audit-logs-list";

export function AuditLogs() {
  return <ListPage config={auditLogsListConfig} />;
}

export function PlatformAuditLogs() {
  return <ListPage config={platformAuditLogsListConfig} />;
}
